// import React, { useState } from "react";
// import {
//   Box,
//   Typography,
//   Radio,
//   RadioGroup,
//   FormControlLabel,
// } from "@mui/material";
// import { ButtonPrimary } from "../../../shared/components/button/Buttons";

// interface Props {
//   handleDialog: any;
// }

// const CollectionFiltersPopup: React.FC<Props> = ({ handleDialog }) => {
//   const [selectedOption, setSelectedOption] = useState("");

//   const handleOptionChange = (event: React.ChangeEvent<HTMLInputElement>) => {
//     setSelectedOption(event.target.value);
//   };

//   const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
//     if (event.key === "Enter") {
//       handleApplySelectFilters();
//     }
//   };

//   const handleApplySelectFilters = () => {
//     handleDialog();
//   };

//   return (
//     <Box
//       sx={{
//         display: "flex",
//         position: "absolute",
//         top: "0px",
//         right: "0px",
//         backgroundColor: "#1B1B1B",
//         border: "1px solid #292929",
//         borderRadius: "14px",
//         maxWidth: "196px",
//         width: "100%",
//         padding: "24px",
//         zIndex: 1000,
//         boxShadow: "0 4px 20px rgba(0, 0, 0, 0.5)",
//         overflow: "hidden",
//       }}
//     >
//       <Box textAlign="center" width="100%">
//         <RadioGroup
//           sx={{ display: "flex", gap: "24px" }}
//           value={selectedOption}
//           onChange={handleOptionChange}
//         >
//           <FormControlLabel
//             value="active"
//             control={
//               <Radio
//                 color="primary"
//                 sx={{
//                   "&.MuiRadio-root": {
//                     color: " #CF0",
//                   },
//                 }}
//               />
//             }
//             label={
//               <Typography
//                 variant="body1"
//                 sx={{ color: "#FFFFFF", fontSize: "18px", fontWeight: "600" }}
//               >
//                 Active
//               </Typography>
//             }
//             sx={{ height: "24px", width: "100%" }}
//           />
//           <FormControlLabel
//             value="inactive"
//             control={
//               <Radio
//                 color="primary"
//                 sx={{
//                   "&.MuiRadio-root": {
//                     color: " #CF0",
//                   },
//                 }}
//               />
//             }
//             label={
//               <Typography
//                 variant="body1"
//                 sx={{ color: "#FFFFFF", fontSize: "18px", fontWeight: "600" }}
//               >
//                 Inactive
//               </Typography>
//             }
//             sx={{ height: "24px" }}
//           />
//           <FormControlLabel
//             value="all"
//             control={
//               <Radio
//                 color="primary"
//                 sx={{
//                   "&.MuiRadio-root": {
//                     color: " #CF0",
//                   },
//                 }}
//               />
//             }
//             label={
//               <Typography
//                 variant="body1"
//                 sx={{ color: "#FFFFFF", fontSize: "18px", fontWeight: "600" }}
//               >
//                 All
//               </Typography>
//             }
//             sx={{ height: "24px" }}
//           />
//           <FormControlLabel
//             value="draft"
//             control={
//               <Radio
//                 color="primary"
//                 sx={{
//                   "&.MuiRadio-root": {
//                     color: " #CF0",
//                   },
//                 }}
//               />
//             }
//             label={
//               <Typography
//                 variant="body1"
//                 sx={{ color: "#FFFFFF", fontSize: "18px", fontWeight: "600" }}
//               >
//                 Draft
//               </Typography>
//             }
//             sx={{ height: "24px" }}
//           />
//         </RadioGroup>
//         {/* Action Buttons  */}
//         <Box sx={{ mt: "24px" }}>
//           <ButtonPrimary
//             sx={{
//               height: "46px !important",
//               width: "112px",
//               padding: "15px 32px",
//               borderRadius: "14px",
//             }}
//             onClick={() => {
//               handleApplySelectFilters();
//             }}
//             LabelStyle={{
//               fontSize: "18px !important",
//               fontWeight: "600",
//               lineHeight: "22px",
//             }}
//             label="Apply"
//           />
//         </Box>
//       </Box>
//     </Box>
//   );
// };

// export default CollectionFiltersPopup;

import React, { useEffect, useRef, useState } from "react";
import {
  Box,
  Typography,
  Checkbox,
  FormControlLabel,
  FormGroup,
} from "@mui/material";
import { ButtonPrimary } from "../../../shared/components/button/Buttons";

interface Props {
  handleDialog: any;
}

const optionsList = ["Active", "Inactive", "All", "Draft"];

const CollectionFiltersPopup: React.FC<Props> = ({ handleDialog }) => {
  const [selectedOptions, setSelectedOptions] = useState<string[]>([]);
  const popupRef = useRef<HTMLDivElement>(null);
  const handleCheckboxChange = (option: string) => {
    setSelectedOptions((prev) =>
      prev.includes(option)
        ? prev.filter((item) => item !== option)
        : [...prev, option]
    );
  };

  const handleApplySelectFilters = () => {
    console.log("Selected Filters:", selectedOptions);
    handleDialog();
  };

  // Outside lick popup close 
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        popupRef.current &&
        !popupRef.current.contains(event.target as Node)
      ) {
        handleDialog();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <Box
      ref={popupRef}
      sx={{
        display: "flex",
        position: "absolute",
        top: "0px",
        right: "0px",
        backgroundColor: "#1B1B1B",
        border: "1px solid #292929",
        borderRadius: "14px",
        maxWidth: "196px",
        width: "100%",
        padding: "24px",
        zIndex: 1000,
        boxShadow: "0 4px 20px rgba(0, 0, 0, 0.5)",
        overflow: "hidden",
      }}
    >
      <Box textAlign="center" width="100%">
        <FormGroup sx={{ display: "flex", gap: "24px" }}>
          {optionsList.map((option, index) => (
            <FormControlLabel
              key={index}
              control={
                <Checkbox
                  checked={selectedOptions.includes(option)}
                  onChange={() => handleCheckboxChange(option)}
                  sx={{
                    color: "#CF0",
                    "&.Mui-checked": {
                      color: "#CF0",
                    },
                  }}
                />
              }
              label={
                <Typography
                  variant="body1"
                  sx={{
                    color: "#FFFFFF",
                    fontSize: "18px",
                    fontWeight: "600",
                  }}
                >
                  {option}
                </Typography>
              }
              sx={{ height: "24px", width: "100%", marginLeft: 0 }}
            />
          ))}
        </FormGroup>

        {/* Action Button */}
        <Box sx={{ mt: "24px" }}>
          <ButtonPrimary
            sx={{
              height: "46px !important",
              width: "112px",
              padding: "15px 32px",
              borderRadius: "14px",
            }}
            onClick={handleApplySelectFilters}
            LabelStyle={{
              fontSize: "18px !important",
              fontWeight: "600",
              lineHeight: "22px",
            }}
            label="Apply"
          />
        </Box>
      </Box>
    </Box>
  );
};

export default CollectionFiltersPopup;
